import * as types from "./types";

const mutations = {
    [types.LOADING_GPSDEVICE](state, value) {
        state.loading = value;
    },
    [types.GET_GPSDEVICE_LIST](state, gpsdevices) {
        state.gpsdevices = gpsdevices;
    },
    [types.REMOVE_GPSDEVICE](state, id) {        
        state.gpsdevices = state.gpsdevices.filter((x) => x.id !== id);        
    },
    [types.ADD_GPSDEVICE](state, gpsdevice) {        
        state.gpsdevices.unshift(gpsdevice);
    },
    [types.UPDATE_GPSDEVICE](state, gpsdevice) {        
        const gpsdeviceIndex = state.gpsdevices.findIndex((x) => x.id === gpsdevice.id);
        state.gpsdevices[gpsdeviceIndex] = gpsdevice;        
    },
    [types.GET_GPSDEVICEBYID](state, gpsdeviceId) {
        state.gpsdeviceId = gpsdeviceId;
    }
};

export default mutations;